<div class="passwordPage">
    <form (ngSubmit)="onSubmit()" #formHandler="ngForm">
        <div class="container">
            <div class="form">
                <div class="portalLogo mb-5"></div>
                <div class="text-center">
                    <h2>Forgot password?</h2>
                    <p>Please enter your registered email address and we will email you instructions on how to reset your password.</p>
                </div>
                <div class="form-group">
                    <input class="form-input" name="email" type="email" id="email-input"
                        placeholder="Email address" [(ngModel)]="email" #emailInput="ngModel"
                        required email/>
                    <label for="email-input" class="form_label">Email address</label>
                    <div [hidden]="emailInput.valid || emailInput.pristine"
                        class="alert alert-danger">
                        <span>Please enter valid email</span>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-4">
                        <button [routerLink]="['']" class="primary-button">
                            Back
                        </button>
                    </div>
                    <div class="col-6 offset-2">
                        <button type="submit" [disabled]="!formHandler.form.valid" class="primary-button" id="submit-button">
                            Request reset
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>